import Moment from "moment/moment";
import CalendarController from "./calendar.controller.js";

export default class MonthCalendarCtrl extends CalendarController {
    static $inject = ['$scope', 'Workloads'];

    constructor() {
        super(...arguments);

        this.workloads = {};
        this.workloadsCache = {};

        // Bindings
        this.showItemColors = null;
    }

    $onInit(){
        this.loadWorkloads();

        this.$scope.$watch(() => this.calendar.date, (oldDate, newDate) => {
            if (!Moment(oldDate).isSame(newDate, 'month')) {
                this.loadWorkloads();
            }
        });
    }

    $onChanges(changes) {
        if (changes.showItemColors && showItemColors == null) {
            this.showItemColors = true;
        }
    }

    workload(col, row) {
        let cacheKey = col.id + row.id;
        let workload = this.workloadsCache[cacheKey];
        if (workload) {
            return workload;
        }

        let date = this.calendar.cellDate(col, row).format('YYYY-MM-DD');
        workload = this.workloads[date];
        if (workload) {
            this.workloadsCache[cacheKey] = workload;
        }

        return workload;
    }

    loadWorkloads() {
        this.workloads = {};
        this.workloadsCache = {};

        let startDate = Moment(this.calendar.date).startOf('month').startOf('week').format('YYYY-MM-DD');
        let endDate = Moment(this.calendar.date).endOf('month').endOf('week').format('YYYY-MM-DD');

        this.Workloads.inDateRange(startDate, endDate).then((workloads) => {
            workloads.forEach((workload) => {
                this.workloads[workload.date] = workload;

                if (workload.percentage >= 90) {
                    workload.color = 'assertive';
                } else if (workload.percentage >= 60) {
                    workload.color = 'energized';
                } else {
                    workload.color = 'positive';
                }
            })
        });
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/components/calendar/month-calendar.controller.js